import { Component, Input, OnInit } from '@angular/core';
import { ViewWillEnter } from '@ionic/angular';
import { ActivatedRoute, Route, Router } from '@angular/router';
import { RequestParams } from '../../../../../../common/rest-api/models/request-params';
import { StopInvoice, StopInvoiceReport } from './models/stopInvoice.model';
import { StopInvoiceService } from './invoice-stop.service';
import { GtrakAuthService } from '../../../../../../../app/features/authentication/services/gtrak-auth.service';

@Component({
  selector: 'app-stop-invoice-page',
  templateUrl: 'invoice.page.html',
  styleUrls: [
     './invoice.page.scss',
     '../../../../styles/g-route.styles.scss'
  ]
})
export class InvoiceStopPage implements ViewWillEnter, OnInit {

    currentRoute: string;
    stopCode: string;
    routeCode: string;

    invoices: StopInvoiceReport;
    requestParams: RequestParams;
    breadcrumbs=[];
    routeStopName: string = "";
    loaded:boolean=false;
    constructor(
        private router: Router,
        private route: ActivatedRoute,
        private stopInvoiceService: StopInvoiceService,
        private authService: GtrakAuthService,
    ) { 
        this.currentRoute = null;
    }

    ngOnInit(): void {
        this.routeStopName = localStorage.getItem('routeStopName');

        this.currentRoute = this.router.url;
        this.stopCode = this.route.snapshot.paramMap.get('id');
        this.routeCode = this.authService.user.routeCode
        this.breadcrumbs.push({ label: 'Home', url: '/route' });
        this.breadcrumbs.push({ label: 'Logsheet', url: '/route/logsheet' });
        this.breadcrumbs.push({ label: 'Stop', url: '/route/logsheet/stop/'+ this.stopCode });
        this.requestParams = new RequestParams();
        this.requestParams.setPaging(1, 0);

        window.dispatchEvent(new Event('resize'));
       
    }

    async ionViewWillEnter(): Promise<void> {
        this.invoices = await this.stopInvoiceService.getInvoices(this.stopCode, this.routeCode, this.requestParams);
        this.loaded=true;
    }

    openInvoice(invoiceNum: any): void {
        this.router.navigate([`invoice/details/${invoiceNum}`]);
    }


}